import React from "react";

/**
 * TikTokIcon - shared brand icon.
 * Accepts explicit props only (no arbitrary prop spreading onto the SVG DOM element).
 */
export const TikTokIcon = ({ size = 17, className = "" }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M16.5 3c.3 2 1.5 3.5 3.5 3.9v2.6c-1.3.1-2.5-.2-3.6-.8v5.8c0 3.3-2.4 5.5-5.4 5.5-3 0-5-2.3-5-5 0-2.9 2.3-5 5.3-4.7v2.7c-.4-.1-.8-.2-1.2-.1-1.2.1-2 .9-2 2.1 0 1.2.9 2.1 2.1 2.1 1.3 0 2.1-.9 2.1-2.5V3h4.2z" />
  </svg>
);
